/* eslint-disable import/prefer-default-export */
import { I18N_DOMAIN } from '../../editor/settings';

const { _nx } = wp.i18n;

/**
 * Outputs the validation warning if all questions are not answered
 *
 * @param {array} quizElement - Array of quizzes on a page/post
 * @param {array} uniqueQuestionIds - Array of unanswered question ids
 * @param {object} event - Object of event click
 * @param {string} postType - string containing the post type
 *
 */
const validationOutput = (
	quizElement,
	uniqueQuestionIds,
	event,
	capitalisedPostType,
	clickElement,
) => {
	// For each question id get the question element, assign a class and add to question number array
	const questionNumbers = uniqueQuestionIds.map((element) => {
		const unansweredQuestion = quizElement.querySelector(`[data-question-id='${element}']`);

		if (clickElement === 'A') {
			unansweredQuestion.classList.add('is-unanswered');
		}

		return unansweredQuestion.dataset.questionNumber;
	});

	if (questionNumbers.length === 0) {
		return;
	}

	// Get the validation element for quiz
	const validationWarning = quizElement.querySelector(
		`.mavis${capitalisedPostType}-validation-warning`,
	);

	// Calculate the remaining unanswered question numbers
	const questionTotal = questionNumbers.length;
	const finalNumber = questionNumbers.pop();
	const numberOutput = questionNumbers.length
		? `${questionNumbers.join(', ')} & ${finalNumber}`
		: finalNumber;

	if (clickElement === 'A' || validationWarning.classList.contains('is-active')) {
		// Update the element innerHTML to output the missing answers
		validationWarning.innerHTML = _nx(
			`You forgot to fill in Question ${numberOutput}`,
			`You forgot to fill in Questions ${numberOutput}`,
			questionTotal,
			'number of questions',
			I18N_DOMAIN,
		);

		// Add class to display the results
		if (!validationWarning.classList.contains('is-active')) {
			validationWarning.classList.add('is-active');
		}

		// Add incomplete quiz class to the submit button to disable it
		event.target.classList.add('missing-answers');
	}
};

/**
 * Handles validation for the quiz on both submit and input choice
 *
 * @param {array} quizElement - Array of quizzes on a page/post
 * @param {object} event - Object of event click
 * @param {string} clickElement - string which can be A or INPUT
 * @param {string} postType - string containing the post type
 *
 */
export const validationCheck = (quizElement, event, clickElement, postType) => {
	const capitalisedPostType = postType.charAt(0).toUpperCase() + postType.slice(1);

	const postTypeInputs = [
		...quizElement.querySelectorAll(`.wp-block-mavis-${postType}-answer input`),
	];

	let selectedInputs;

	if (postType === 'trivia') {
		selectedInputs = postTypeInputs
			.filter((element) => element.checked === false)
			.filter((element) => element.disabled !== true);
	}
	if (postType === 'personality') {
		selectedInputs = postTypeInputs
			.filter((element) => element.checked === false)
			.filter((element) => !element.classList.contains('mavisPersonality-question-answered'));
	}

	const answeredQuestions = selectedInputs.map(
		(el) => el.closest(`.wp-block-mavis-${postType}-question`).dataset.questionId,
	);

	// Remove any duplicates from the array of question ids
	let uniqueQuestionIds = [...new Set(answeredQuestions)];

	// If event click was on an input
	if (clickElement === 'INPUT') {
		// Get the relevant question id to the selected answer
		const currentQuestionId = event.target.closest(`.wp-block-mavis-${postType}-question`).dataset
			.questionId;

		// Remove the selected answer from the array of question IDS
		uniqueQuestionIds = uniqueQuestionIds.filter((item) => item !== currentQuestionId);

		validationOutput(quizElement, uniqueQuestionIds, event, capitalisedPostType, clickElement);
	}

	// If event click was on the submit button
	if (clickElement === 'A') {
		validationOutput(quizElement, uniqueQuestionIds, event, capitalisedPostType, clickElement);
	}
};
